import { Icon as ReshapedIcon } from "reshaped";

import { iconsComponents } from "./constants";
import type { IconName } from "./types";

type IconProps = {
    name: IconName;
};

export default function Icon(props: IconProps) {
    const { name } = props;
    return <ReshapedIcon svg={iconsComponents[name]} />;
}
